/**
 * Text with every case-insensitive occurrence of the search term marked, so people can see why a
 * result matched as they type.
 */
export function Highlight({ text, term }: { text: string; term?: string | undefined }) {
  const needle = term?.trim();
  if (!needle) return <>{text}</>;

  const lower = text.toLowerCase();
  const find = needle.toLowerCase();
  const parts: { text: string; hit: boolean }[] = [];
  let from = 0;
  for (let at = lower.indexOf(find); at >= 0; at = lower.indexOf(find, from)) {
    if (at > from) parts.push({ text: text.slice(from, at), hit: false });
    parts.push({ text: text.slice(at, at + find.length), hit: true });
    from = at + find.length;
  }
  if (from < text.length) parts.push({ text: text.slice(from), hit: false });

  return (
    <>
      {parts.map((part, index) =>
        part.hit ? (
          <mark key={index} className="hit">
            {part.text}
          </mark>
        ) : (
          <span key={index}>{part.text}</span>
        ),
      )}
    </>
  );
}
